module.exports = __webpack_public_path__ + "assets/img/Type E (34).8ad71f83.jpg";